module.exports = __webpack_public_path__ + "46950fde6d5dc1b76ec668c56d7ce74c.png";